import { differenceInDays, isFuture } from 'date-fns';

import { confluenceLocalStorageInstance } from '@confluence/storage-manager/entry-points/storageInstance.ts';

export const AI_IN_EDITOR_END_OF_TRIAL_MODAL_LAST_SHOWN_TS =
	'confluence_ai_in_editor_eot_modal_last_shown_ts';

export const recordModalShown = (): void => {
	const now = Date.now();
	confluenceLocalStorageInstance.setItem(
		AI_IN_EDITOR_END_OF_TRIAL_MODAL_LAST_SHOWN_TS,
		now.toString(),
	);
};

export const getLastModalDisplayTime = (): number | null => {
	const lastShownTs = confluenceLocalStorageInstance.getItem(
		AI_IN_EDITOR_END_OF_TRIAL_MODAL_LAST_SHOWN_TS,
	);
	return lastShownTs ? parseInt(lastShownTs, 10) : null;
};

export const showModalBasedOnLastDisplayTime = (
	trialEndDate: string,
	trialDaysLeft: number,
): boolean => {
	//do not show after trial has ended
	if (!isFuture(new Date(trialEndDate))) {
		return false;
	}

	const lastShownTs = getLastModalDisplayTime();

	const daysSinceLastShown = lastShownTs ? differenceInDays(new Date(), new Date(lastShownTs)) : 0;

	//first time check
	const showModalAtFiveDaysBeforeEndOfTrial = trialDaysLeft === 5;
	if (showModalAtFiveDaysBeforeEndOfTrial && !lastShownTs) {
		return true;
	}
	if (trialDaysLeft === 3 && (!lastShownTs || daysSinceLastShown >= 2)) {
		return true;
	}
	if (trialDaysLeft === 1 && (!lastShownTs || daysSinceLastShown >= 2)) {
		return true;
	}
	return false;
};
